import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Footer = () => {
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        const navHeight = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - navHeight;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    }, 100);
  };

  return (
    <footer>
      <div className="footer-content">
        <div className="footer-section">
          <h3>RAIX</h3>
          <p>The ultimate all-in-one Discord bot for your server. Built with passion and dedication.</p>
        </div>
        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul className="footer-links">
            <li><Link to="/">Home</Link></li>
            <li><button onClick={() => scrollToSection('features')} className="footer-link-btn">Features</button></li>
            <li><button onClick={() => scrollToSection('commands')} className="footer-link-btn">Commands</button></li>
            <li><button onClick={() => scrollToSection('about')} className="footer-link-btn">About Us</button></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Legal</h3>
          <ul className="footer-links">
            <li><Link to="/privacy">Privacy Policy</Link></li>
            <li><Link to="/terms">Terms of Service</Link></li>
            <li><Link to="/cookies">Cookie Policy</Link></li>
          </ul>
        </div>
        <div className="footer-section">
          <h3>Connect</h3>
          <ul className="footer-links">
            <li><a href="https://discord.gg/5tUh6aktZw" target="_blank" rel="noopener noreferrer">Support Server</a></li>
            <li><a href="https://discord.com/oauth2/authorize?client_id=1430529243254751353" target="_blank" rel="noopener noreferrer">Add to Discord</a></li>
            <li><a href="mailto:factsonly9667@gmail.com">Email Us</a></li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; 2024 Raix. Developed by RaiMohan & RaiSunny. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
